interface YogaIconProps {
  color?: string;
}
export const YogaIcon = ({ color }: YogaIconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clipPath="url(#clip0_5651_6312)">
      <path d="M8 4C9.10457 4 10 3.10457 10 2C10 0.895431 9.10457 0 8 0C6.89543 0 6 0.895431 6 2C6 3.10457 6.89543 4 8 4Z" fill={color ?? '#000'}/>
      <path d="M3.33341 11.3335C3.1566 11.3335 2.98703 11.4037 2.86201 11.5288C2.73699 11.6538 2.66675 11.8234 2.66675 12.0002C2.66675 12.177 2.73699 12.3465 2.86201 12.4716C2.98703 12.5966 3.1566 12.6668 3.33341 12.6668H12.6667C12.8436 12.6668 13.0131 12.5966 13.1382 12.4716C13.2632 12.3465 13.3334 12.177 13.3334 12.0002C13.3334 11.8234 13.2632 11.6538 13.1382 11.5288C13.0131 11.4037 12.8436 11.3335 12.6667 11.3335H3.33341Z" fill={color ?? '#000'}/>
      <path d="M16 14H0V15.3333H16V14Z" fill={color ?? '#000'}/>
      <path d="M5.99991 6.7825V10.6665H9.99991V6.7825L11.2326 7.83917C11.3505 7.94034 11.5 7.99716 11.6553 7.99984C11.8106 8.00252 11.962 7.95088 12.0832 7.85384L14.2706 6.10384L13.4372 5.0625L11.6812 6.4665L9.95458 4.9865C9.71271 4.77967 9.40483 4.66616 9.08658 4.6665H6.91325C6.59529 4.66685 6.28791 4.78082 6.04658 4.98784L4.31858 6.4665L2.56258 5.0625L1.72925 6.10384L3.91658 7.85384C4.03787 7.95088 4.18925 8.00252 4.34456 7.99984C4.49987 7.99716 4.64937 7.94034 4.76725 7.83917L5.99991 6.7825Z" fill={color ?? '#000'}/>
    </g>
  <defs>
    <clipPath id="clip0_5651_6312">
      <rect width="16" height="16" fill="white"/>
    </clipPath>
  </defs>
  </svg>
);
